import React from 'react';
import * as S from './References.styles';

export const References: React.FC = () => {
  return (
    <S.ReferencesWrapper>
      <S.Text>Made by VDA VINA</S.Text>
    </S.ReferencesWrapper>
  );
};
